<template>
  <v-dialog v-model="dialog" width="500" v-if="item && type">
    <template v-slot:activator="{ on }">
      <span v-on="on"> {{ deleteProperties.title }} </span>
    </template>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ deleteProperties.title }}
      </v-card-title>

      <v-card-text>
        {{ deleteProperties.deleteMessage }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialog = false"> Cancel </v-btn>
        <v-btn
          color="primary"
          flat
          @click="deleteItem()"
          :loading="deleteProperties.loading"
        >
          {{ deleteProperties.buttonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UsersService from "@/services/users.service";
import ApiService from "@/services/api.service";

export default {
  props: ["type", "item"],
  data: function () {
    return {
      dialog: false,
      deleteProperties: {
        item: null,
        message: "",
        loading: false,
        title: "",
        deleteButton: "",
      },
    };
  },
  methods: {
    async deleteItem() {
      this.deleteProperties.loading = true;
      try {
        const id = this.deleteProperties.item.id;
        if (id) {
          await ApiService.query(this.deleteProperties.endpoint + id);
          UsersService.trackEvent({
            model: "DOCUMENT",
            modelId: this.deleteProperties.item.id,
            message: this.deleteProperties.logMessage,
            reference: this.deleteProperties.type,
            type: this.deleteProperties.type,
          });
        }
      } catch (error) {
        // console.log("delete error", error);
      }

      this.deleteProperties.loading = false;
      this.dialog = false;
      this.$emit('completed');
    },
  },
  mounted() {
    if (this.type == "PAGE") {
      this.deleteProperties = {
        endpoint: "/ocr/delete/page/",
        type: "DELETE_PAGE",
        deleteMessage: "Click to delete page.",
        logMessage: "Page Deleted",
        item: { ...this.item },
        loading: false,
        title: "Delete Page",
        buttonText: "Delete Page",
      };
    } else {
      this.deleteProperties = {
        endpoint: "/ocr/delete/document/",
        type: "DELETE_DOCUMENT",
        deleteMessage:
          "All pages in this document will be deleted. Click to proceed.",
        item: { ...this.item },
        logMessage: "Document Deleted",
        loading: false,
        title: "Delete Document",
        buttonText: "Delete Document",
      };
    }
  },
};
</script>
